<div
  class="badge"
  [ngClass]="colorScheme()"
>
  @if (iconName()) {
    <i-feather
      [name]="iconName()"
      [style.width.px]="14"
      [style.height.px]="14"
    ></i-feather>
  }
  @if (label()) {
    <div
      class="badge-text"
      [ngStyle]="{ 'white-space': wrap() ? 'normal' : 'nowrap' }"
    >
      {{ label() }}
    </div>
  }
</div>
